import { Component, Input, Output, EventEmitter, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";

@Component({
	selector: "app-confirmation-modal",
	templateUrl: "./confirmation-modal.component.html",
	styleUrls: ["./confirmation-modal.component.scss"],
})
export class ConfirmationModalComponent {
	@Output() confirm = new EventEmitter<any>();
	@Input() confimationMessage = "";

	constructor(
		private params: ActivatedRoute,
		private dialogRef: MatDialogRef<ConfirmationModalComponent>,
		@Inject(MAT_DIALOG_DATA) private data: {confirmationMessage: string}
		) {
		if(data != null){
			this.confimationMessage = data.confirmationMessage
		}
	}

	async closeModal(confirmationResult: boolean) {
		this.dialogRef.close(confirmationResult);
	}
}
